import PUR01_009RPT from "@/views/MIPUR/PUR01_009RPT.vue";
import PUR01_010RPT from "@/views/MIPUR/PUR01_010RPT.vue";
import PUR01_034INS from "@/views/MIPUR/PUR01_034INS.vue";
import PUR02_012RPT from "@/views/MIPUR/PUR02_012RPT.vue";
import PUR02_014RPT from "@/views/MIPUR/PUR02_014RPT.vue";
import PUR02_015INS from "@/views/MIPUR/PUR02_015INS.vue";
import PUR02_016RPT from "@/views/MIPUR/PUR02_016RPT.vue";
import PUR02_017INS from "@/views/MIPUR/PUR02_017INS.vue";
import PUR02_018INS from "@/views/MIPUR/PUR02_018INS.vue";
import PUR02_029RPT from "@/views/MIPUR/PUR02_029RPT.vue";
import PUR02_029RPT_02 from "@/views/MIPUR/PUR02_029RPT_02.vue";
import PUR02_030RPT_02 from "@/views/MIPUR/PUR02_030RPT_02.vue";
import PUR02_031INS from "@/views/MIPUR/PUR02_031INS.vue";
import PUR02_035RPT from "@/views/MIPUR/PUR02_035RPT.vue";
import PUR03_005INS from "@/views/MIPUR/PUR03_005INS.vue";
import PUR03_006INS from "@/views/MIPUR/PUR03_006INS.vue";
import PUR03_006RPT from "@/views/MIPUR/PUR03_006RPT.vue";
import PUR03_007RPT from "@/views/MIPUR/PUR03_007RPT.vue";
import PUR03_016RPT from "@/views/MIPUR/PUR03_016RPT.vue";
import PUR03_018RPT from "@/views/MIPUR/PUR03_018RPT.vue";
import PUR03_035INS from "@/views/MIPUR/PUR03_035INS.vue";
import PUR03_036RPT from "@/views/MIPUR/PUR03_036RPT.vue";
import PUR03_037RPT from "@/views/MIPUR/PUR03_037RPT.vue";
import PUR04_001INS from "@/views/MIPUR/PUR04_001INS.vue";
import PUR01_019INS from "@/views/MIPUR/PUR01_019INS.vue";
import PUR01_026RPT from "@/views/MIPUR/PUR01_026RPT.vue";
import PUR08_001INS from "@/views/MIPUR/PUR08_001INS.vue";
import PUR08_002INS from "@/views/MIPUR/PUR08_002INS.vue";
import PUR08_003INS from "@/views/MIPUR/PUR08_003INS.vue";
import PUR08_004INS from "@/views/MIPUR/PUR08_004INS.vue";
import PUR01_032INS from "@/views/MIPUR/PUR01_032INS.vue";
import PUR01_099RPT from "@/views/MIPUR/PUR01_099RPT.vue";

export default function mipurRouter() {
  return [
    {
      path: "PUR03_006INS.xml",
      component: PUR03_006INS,
    },
    {
      path: "PUR01_010RPT.xml",
      component: PUR01_010RPT,
    },
    {
      path: "PUR03_016RPT.xml",
      component: PUR03_016RPT,
    },
    {
      path: "PUR02_031INS.xml",
      component: PUR02_031INS,
    },
    {
      path: "PUR02_015INS.xml",
      component: PUR02_015INS,
    },
    {
      path: "PUR02_016RPT.xml",
      component: PUR02_016RPT,
    },
    {
      path: "PUR02_012RPT.xml",
      component: PUR02_012RPT,
    },
    {
      path: "PUR01_009RPT.xml",
      component: PUR01_009RPT,
    },
    {
      path: "PUR04_001INS.xml",
      component: PUR04_001INS,
    },
    {
      path: "PUR03_005INS.xml",
      component: PUR03_005INS,
    },
    {
      path: "PUR03_006RPT.xml",
      component: PUR03_006RPT,
    },
    {
      path: "PUR02_014RPT.xml",
      component: PUR02_014RPT,
    },
    {
      path: "PUR03_035INS.xml",
      component: PUR03_035INS,
    },
    {
      path: "PUR03_036RPT.xml",
      component: PUR03_036RPT,
    },
    {
      path: "PUR03_037RPT.xml",
      component: PUR03_037RPT,
    },
    {
      path: "PUR02_017INS.xml",
      component: PUR02_017INS,
    },
    {
      path: "PUR02_018INS.xml",
      component: PUR02_018INS,
    },
    {
      path: "PUR01_019INS.xml",
      component: PUR01_019INS,
    },
    {
      path: "PUR01_026RPT.xml",
      component: PUR01_026RPT,
    },
    {
      path: "PUR02_035RPT.xml",
      component: PUR02_035RPT,
    },
    {
      path: "PUR08_003INS.xml",
      component: PUR08_003INS,
    },
    {
      path: "PUR08_004INS.xml",
      component: PUR08_004INS,
    },
    {
      path: "PUR03_007RPT.xml",
      component: PUR03_007RPT,
    },
    {
      path: "PUR03_018RPT.xml",
      component: PUR03_018RPT,
    },
    {
      path: "PUR02_029RPT_02.xml",
      component: PUR02_029RPT_02,
    },
    {
      path: "PUR02_030RPT_02.xml",
      component: PUR02_030RPT_02,
    },
    {
      path: "PUR01_034INS.xml",
      component: PUR01_034INS,
    },
    {
      path: "PUR08_001INS.xml",
      component: PUR08_001INS,
    },
    {
      path: "PUR08_002INS.xml",
      component: PUR08_002INS,
    },
    {
      path: "PUR02_029RPT.xml",
      component: PUR02_029RPT,
    },
    {
      path: "PUR01_032INS.xml",
      component: PUR01_032INS,
    },
    {
      path: "PUR01_099RPT.xml",
      component: PUR01_099RPT,
    }
  ];
}
